export default "assets/images/icons/slider-arrow-da67149c.png";